(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-hero-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHeroSlider(root) {
    var slides = root.querySelectorAll('.nb-hero-slide');
    var dotsContainer = root.querySelector('.nb-hero-dots');
    var prevBtn = root.querySelector('.nb-hero-arrow-prev');
    var nextBtn = root.querySelector('.nb-hero-arrow-next');
    var interval = parseInt(root.getAttribute('data-autoplay'), 10) || 6000;
    var current = 0;
    var timer = null;

    if (!slides.length) return;

    if (slides.length <= 1) {
      if (dotsContainer) dotsContainer.style.display = 'none';
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }

    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === 0) dot.classList.add('is-active');
        dot.addEventListener('click', function () { goTo(i); });
        dotsContainer.appendChild(dot);
      });
    }

    function render() {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
      if (dotsContainer) {
        Array.prototype.forEach.call(dotsContainer.children, function (d, i) {
          d.classList.toggle('is-active', i === current);
        });
      }
    }
    function goTo(i) {
      current = (i + slides.length) % slides.length;
      render();
      restart();
    }
    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }
    function restart() {
      clearInterval(timer);
      if (interval > 0) timer = setInterval(next, interval);
    }

    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);

    render();
    restart();
  }

  document.querySelectorAll('.nb-hero').forEach(initHeroSlider);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-results"] && !Shopify.designMode) return;
  try {
    
(function () {
  function createSlider(root, slideSelector, dotsSelector, interval) {
    var slides = Array.prototype.slice.call(root.querySelectorAll(slideSelector));
    var dotsContainer = root.querySelector(dotsSelector);
    if (!slides.length) return;
    var current = 0;
    var timer = null;

    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === 0) dot.classList.add('is-active');
        dot.addEventListener('click', function () { goTo(i); });
        dotsContainer.appendChild(dot);
      });
    }

    function render() {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
      if (dotsContainer) {
        Array.prototype.forEach.call(dotsContainer.children, function (d, i) {
          d.classList.toggle('is-active', i === current);
        });
      }
    }
    function goTo(i) {
      current = (i + slides.length) % slides.length;
      render();
      restart();
    }
    function next() { goTo(current + 1); }
    function restart() {
      clearInterval(timer);
      if (interval) timer = setInterval(next, interval);
    }
    render();
    restart();
  }

  function initDragCompare(compare) {
    var wrap = compare.querySelector('.nb-ba-before-wrap');
    var handle = compare.querySelector('.nb-ba-handle');
    if (!wrap || !handle) return;
    var dragging = false;

    function setPosition(clientX) {
      var rect = compare.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      wrap.style.width = pct + '%';
      handle.style.left = pct + '%';
    }
    function start(e) { dragging = true; move(e); }
    function move(e) {
      if (!dragging) return;
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setPosition(clientX);
    }
    function end() { dragging = false; }

    handle.addEventListener('mousedown', start);
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', end);
    handle.addEventListener('touchstart', start, { passive: true });
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('touchend', end);
    compare.addEventListener('click', function (e) {
      if (e.target === handle) return;
      setPosition(e.clientX);
    });
  }

  document.querySelectorAll('.nb-results').forEach(function (root) {
    createSlider(root, '.nb-ba-slide', '.nb-ba-dots', 7000);
    createSlider(root, '.nb-testimonial', '.nb-testimonial-dots', 5000);
    root.querySelectorAll('.nb-ba-compare').forEach(initDragCompare);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
